var storefrontApp = angular.module('storefrontApp');
storefrontApp.run(['$templateCache', function ($templateCache) {
    // cache application level templates
    $templateCache.put('searchPagerTemplate.html', '' +
        '<uib-pagination boundary-links="true" max-size="pageSettings.numPages" items-per-page="pageSettings.itemsPerPageCount" ' +
        'total-items="pageSettings.totalItems" ng-model="pageSettings.currentPage" ng-change="pageSettings.pageChanged()" ' +
        'class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination>');
}])

storefrontApp.controller('customerSearchBarController', ['$scope', '$timeout', '$window', 'customerService', function ($scope, $timeout, $window, customerService) {
    var timer;

    var $ctrl = this;
    
    $scope.isCancelling = false;
    $scope.isRedirecting = false;

    $scope.initScroll = function () {
        setTimeout(
            function () {
                $("#Customer-Search-Clear").show();
            }
        , 1);
    }

    $scope.query = $window.searchQuery;

    $scope.pageSettings = { currentPage: 1, itemsPerPageCount: 5, numPages: 50};
    $scope.pageSettings.pageChanged = function () {
        $scope.getSuggestions("");
    };

    $scope.getSuggestions = function (officeId) {
        if (!$scope.firstname && !$scope.lastname && !$scope.phone && !$scope.email) {
            return;
        }
        if (officeId != "") {
            // User submitted a new search
            $scope.officeId = officeId;
            $scope.pageSettings.currentPage = 1;  // reset current page for new searches
        }

        $scope.searching = true;
        $("#SearchAccount").addClass("loading");
        $scope.customerSuggestions = [];

        var searchCriteria = {
            FirstName: $scope.firstname, LastName: $scope.lastname,
            Email: $scope.email,
            Phone: $scope.phone,
            OrganizationId: $scope.officeId,
            PageNumber: $scope.pageSettings.currentPage,
            PageSize: $scope.pageSettings.itemsPerPageCount
        };

        customerService.quickSearchPatients(searchCriteria).then(function (response) {
            var userList = response.data;
            $scope.customerSuggestions = userList;
            $scope.searching = false;
            $("#SearchAccount").removeClass("loading");
            $scope.pageSettings.totalItems = response.data.totalCount;
        });
    }

    $scope.cancel = function () {
        $scope.isCancelling = true;
        $window.location.href = "/";
    }

    $scope.goToCreateCustomer = function () {
        $scope.isRedirecting = true;
        $window.location.href = "/account/register";
    }

    this.$routerOnActivate = function (next) {
        $ctrl.pageSettings.currentPage = next.params.pageNumber || $ctrl.pageSettings.currentPage;
        $ctrl.pageSettings.pageChanged();
    };


}]);

